import type { TFunction } from 'i18next'

/* A transit time in days, as the reader says it.
 *
 * Lifted out of the quote's route-option row (`RouteOptionsCard`) when the case
 * overview became its second reader (P0-2): the case carries the range its
 * quote stated, and two copies of this sentence would word one agreement two
 * ways on two screens. The keys stay under `quotes.routes` where they were
 * written — moving them would rename a catalogue entry to match a file, which is
 * churn with no reader on the other end.
 *
 * A one-sided range says WHICH side is known. "16 days" and "up to 16 days" are
 * different promises to a client, and collapsing the second into the first
 * would print a guarantee nobody gave.
 */

/** The range as one short phrase — «12–16 дн», «14 дней», «до 20 дн» — or
 *  undefined when neither end is stated, so a caller dashes it rather than
 *  printing an empty string. */
export function transitRange(
  { min, max }: { min?: number | null; max?: number | null },
  t: TFunction,
): string | undefined {
  if (min != null && max != null) {
    return min === max
      ? t('quotes.routes.transitDays', { count: min })
      : `${min}–${max} ${t('quotes.routes.daysShort')}`
  }
  if (max != null) return t('quotes.routes.transitUpTo', { count: max })
  if (min != null) return t('quotes.routes.transitFrom', { count: min })
  return undefined
}
